import { StyledLink, StyledLinkProps, StyledRouterLink } from './Link.styles';
import { LinkProps } from 'react-router-dom';

type Props = Partial<LinkProps> &
  StyledLinkProps & {
    'data-testid'?: string;
  };

export const Link = ({ to, ...props }: Props) =>
  to ? <StyledRouterLink to={to} {...props} /> : <StyledLink {...props} />;
